import React from 'react'

const Card = (props = {}) => {
  return <div className={'card ' + props.className}>{props.children}</div>
}

export default Card



// WEBPACK FOOTER //
// ./src/common/ui/good_components/Card.jsx